<template>
  <div v-if="!isLoading">
    <div class="mt-5">
      <div v-if="current.imbpBookings.data.bookings.length">
        <template v-if="current.imbpBookings.data.bookings.length">
          <SoWidget
            v-for="(booking, index) in current.imbpBookings.data.bookings"
            :key="index"
            class="mb-4"
          >
            <h5 class="mb-4">{{ getBookingJobDetails(booking) }}</h5>
            <div class="d-flex justify-space-between align-center">
              <div>
                <p v-if="booking.displayJobNumber" class="mb-1">
                  <span class="font-weight-medium">Job Reference Number:</span>
                  {{ booking.displayJobNumber }}
                </p>
                <p v-if="booking.mpan" class="mb-1">
                  <span class="font-weight-medium">MPAN:</span>
                  {{ booking.mpan }}
                </p>
                <p v-if="booking.mprn" class="mb-1">
                  <span class="font-weight-medium">MPRN:</span>
                  {{ booking.mprn }}
                </p>
                <p v-if="booking.electricityMeterSerialNumber">
                  <span class="font-weight-medium">Meter:</span>
                  {{ booking.electricityMeterSerialNumber }}
                </p>
                <p v-if="booking.gasMeterSerialNumber">
                  <span class="font-weight-medium">Meter:</span>
                  {{ booking.gasMeterSerialNumber }}
                </p>
              </div>
              <div>
                <p class="mb-1">{{ booking.dateFormatted }}</p>
                <p>{{ booking.timeSlotFormatted }}</p>
              </div>
              <SoStatus :status="booking.status" />

              <SoButton
                title="Details"
                @click="
                  ;((bookingDetailsToOpen = index),
                    (isBookingDetailsModalOpen = true))
                "
              />
            </div>
          </SoWidget>
        </template>
      </div>

      <SoAlert
        v-if="current.imbpBookings.data.hasActiveBooking"
        class="mt-4"
        type="info"
      >
        There is an upcoming appointment for this customer. If this appointment
        is incorrect or needs rescheduling, cancel this before booking a new
        one. Only one booking is allowed at a time.
      </SoAlert>

      <SoAlert
        v-else-if="
          !hideAvailabilityAlert &&
          (current.imbpAvailability.isError ||
            !current.imbpAvailability.data.hasAvailableSlots)
        "
        class="mt-4"
        type="error"
      >
        We couldn't find any available appointment slots for the selected
        account. Please try refreshing the page, or consider checking back
        later.
      </SoAlert>

      <SoAlert v-if="current.imbpAccount.isError" class="mt-4" type="error">
        There was a error retrieving the account details
      </SoAlert>

      <SoAlert
        v-else-if="!current.imbpBookings.data.bookings.length"
        class="mt-4"
        type="info"
      >
        No past or future appointments
      </SoAlert>
    </div>

    <BookingDetailsModal
      v-if="isBookingDetailsModalOpen && bookingDetailsToOpen !== null"
      v-model="isBookingDetailsModalOpen"
      :booking="current.imbpBookings.data.bookings[bookingDetailsToOpen]"
      :booking-job-details="
        getBookingJobDetails(
          current.imbpBookings.data.bookings[bookingDetailsToOpen],
        )
      "
      @close-modal="bookingDetailsToOpen = null"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import BookingDetailsModal from "@/views/customer/imbp/modals/BookingDetailsModal.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { Status } from "@/types/Status"
  import { appointmentTypesAES, meterTypesAES } from "@/constants/imbp"
  import { AccountService } from "@/services/AccountService"

  export default defineComponent({
    components: {
      SoAlert,
      SoStatus,
      SoButton,
      BookingDetailsModal,
      SoWidget,
    },
    props: {
      hideAvailabilityAlert: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        Status,
        isBookingDetailsModalOpen: false,
        bookingDetailsToOpen: null as number | null,
      }
    },
    computed: {
      isLoading() {
        return (
          this.current.imbpAccount.isFetching ||
          this.current.imbpBookings.isFetching
        )
      },
    },
    mounted() {
      // This query must be cached to avoid resetting the flow when further data is requested
      AccountService.getAccount(this.current.accountNumber).refetch()
    },
    methods: {
      getBookingJobDetails(booking) {
        const appointmentType = appointmentTypesAES.find(
          (item) => item.value === booking.appointmentType,
        )
        const jobType = meterTypesAES.find(
          (item) => item.text === booking.meterType,
        )
        const appointment = appointmentType ? appointmentType.title : ""
        const job = jobType ? jobType.text : ""
        return `${job} - ${appointment}`
      },
    },
  })
</script>
